// Lo que se guarda en el navegador del alumno sin preguntar, y lo que no.
//
// POR QUE EXISTE ESTO. La política de cookies llevaba escrito, de las marcas de referidos,
// que «esto no hace falta para que la plataforma funcione, así que solo se activa si dices
// que sí». Y no era verdad: `RefTracker` escribía `alpha_ref` y `alpha_visitor` en cuanto
// llegaba un `?ref=` en la dirección, sin preguntar nada a nadie. El texto iba por delante
// del código, que es exactamente la avería de los plazos de conservación, otra vez.
//
// El artículo 22.2 de la LSSI-CE no distingue entre cookies y `localStorage`: lo que mira es
// si haces falta guardar algo en el aparato de alguien para prestar el servicio. La sesión y
// las preferencias, sí. Saber que este visitante llegó por la invitación de otro, no.
//
// LO QUE SE DECIDIÓ, Y POR QUÉ NO HAY CARTEL DE COOKIES. Un aviso en todas las visitas es lo
// que hace todo el mundo y es lo peor de las dos opciones: molesta a quien no tenía nada que
// consentir y enseña a decir que sí sin leer. Aquí el momento en que hace falta preguntar es
// exacto y es raro —solo cuando alguien llega por un enlace de invitación—, así que se
// pregunta ahí, una vez, con el motivo delante. Quien entra por su cuenta no ve nada, porque
// no hay nada que consentir.
//
// TRES REGLAS que este fichero sostiene:
//
//   1. **Sin respuesta no es un sí.** `puede()` devuelve `false` mientras no haya un sí
//      explícito. Es la diferencia entre pedir permiso y avisar de que ya lo has hecho.
//   2. **Un «no» se guarda.** Guardar la negativa es lo único que permite respetarla sin
//      volver a preguntar en cada página, y es lo que la propia AEPD admite como necesario.
//   3. **Retirar el permiso borra lo que se guardó con él.** Un permiso que se puede quitar
//      pero deja el rastro puesto no se ha quitado. De ahí `olvida()`.
//
// Vive sin React y recibe el almacén por parámetro, como `preferencias.mjs`: así se puede
// probar con un objeto de mentira. Lo comprueba `scripts/prueba_consentimiento.mjs`.

export const CLAVE = "alpha_consentimiento";

/**
 * Lo que se guarda sin preguntar porque sin ello no hay servicio: la sesión, cómo quiere ver
 * la plataforma quien la usa —hace falta ANTES de que exista ninguna cuenta, en la propia
 * pantalla de entrar— y la respuesta a esta misma pregunta.
 */
export const NECESARIO = [
  // AQUÍ ESTABA LA LLAVE DE LA SESIÓN, y se fue el 2 de septiembre. Ya no se guarda en el
  // navegador: vive solo en la cookie `httponly`, que no es almacenamiento de la página y por
  // eso no se declara aquí. Una llave menos que guardar es una llave menos que explicar, que
  // pedir y que borrar.
  "alpha_preferencias",       // cómo quiere ver la plataforma: hace falta antes de entrar
  // EL SONIDO VIVE EN `alpha_preferencias`, con el resto de ajustes. Esta llave es la del
  // botón de silencio de antes, y se sigue leyendo UNA vez para heredarle el silencio a quien
  // ya lo había elegido. No se escribe nunca más, pero mientras se lea hay que declararla.
  "alpha_muted",              // el interruptor de antes: se lee una vez y se hereda
  "alpha_aviso_plan_visto",   // que ya ha visto el aviso de fin de plan, para no repetirlo
  // EL CHECK-IN DE ENERGIA, y es la unica de esta lista que vive en `sessionStorage`: muere
  // al cerrar la pestaña. Se declara igual porque el portero mira lo que el codigo GUARDA, no
  // donde, y porque una llave sin clasificar es una decision tomada por descuido. Es
  // necesaria y no opcional por un motivo concreto: sin ella habria que preguntar en cada
  // pantalla, y preguntarle a alguien cinco veces al dia como viene es peor que no
  // preguntarle. Nunca sale del navegador ni llega al servidor.
  // Se llama `checkin` y no `energia` porque en la politica se lee como texto, y «energia»
  // sin tilde es una falta: el portero de tildes la caza, y hace bien.
  "alpha_checkin",            // con cuanta bateria viene hoy: para bajar lo que se le exige
  // LAS VECES QUE HA CURADO A LA CRIA, del minijuego de la osa del Auditorio. Va en NECESARIO y
  // no en CON_PERMISO, y la razón conviene dejarla escrita porque la decisión no es obvia:
  //
  //   · Es el estado del propio juego que el alumno ha ACEPTADO empezar —hay una puerta y hay
  //     que decir que sí—, así que es parte de lo que ha pedido, no algo que se le hace encima.
  //   · Es un número. Ni nombre, ni identificador, ni cuándo jugó, ni cuánto tardó. No sirve
  //     para reconocer a nadie ni para perfilar a nadie.
  //   · Nunca sale del navegador: no hay `fetch` que la toque, y hay una prueba que lo vigila.
  //
  // Preguntarle a un menor si le dejamos recordar cuántas veces ha ganado a un juego sería una
  // pregunta más sin ninguna ganancia de privacidad, y cada pregunta que no aporta nada gasta la
  // atención que hace falta para la que sí. El día que esta cuenta suba al servidor o cuente
  // para la Liga deja de ser esto y hay que volver a decidirlo.
  "alpha_osa_curada",         // veces que ha curado a la cría: el estado del juego que aceptó
  // EL ÚLTIMO DÍA DEL VIAJE DE LA ESTRELLA, que entra el 1 de noviembre de 2026 y se queda aquí
  // porque es parte de cómo se ve la plataforma: una fecha sin hora y sin nada de quién es, que
  // nunca sale del navegador. Sin ella, el viaje entero saldría en cada lección.
  "alpha_viaje_visto",          // qué día vio ya el viaje entero: para no repetírselo ese día
  // Y LA MEJOR RACHA DE FINTAS, que entra el 11 de septiembre de 2026 por el mismo razonamiento
  // palabra por palabra: es un número, sin nombre, sin fecha y sin identificador, del estado de
  // un juego que el alumno ha aceptado empezar, y nunca sale del navegador. Si algún día una de
  // las dos sube al servidor o cuenta para la Liga, las dos dejan de ser esto.
  "alpha_osa_racha",          // la mejor racha de fintas: lo bien que lo hizo, no quién es
  // Y LA MEJOR RECOGIDA DE CADA TRAMO DEL RECORRIDO, que entra el 19 de septiembre de 2026 por
  // el mismo razonamiento y con el mismo compromiso. Es un mapa de números —tramo: cuántas
  // luces—, sin nombre, sin fecha y sin identificador, del estado de un juego que el alumno ha
  // aceptado empezar. Nunca sale del navegador: `marcaDelRecorrido.mjs` no tiene un solo
  // `fetch`, y hay una prueba que lo vigila. El día que cuente para la Liga o suba al
  // expediente deja de ser esto y hay que volver a decidirlo.
  "alpha_recorrido_marcas",   // cuántas luces cogiste como máximo en cada tramo
  // Y LAS TANDAS DEL ÁRBOL QUE HAS DEJADO ENTERO, que entra el 21 de septiembre de 2026 por el
  // mismo razonamiento y con el mismo compromiso: un mapa de números —tanda: veces—, sin nombre,
  // sin fecha y sin identificador, del estado de un juego que el alumno ha aceptado empezar.
  // `recuerdoDelArbol.mjs` no tiene un solo `fetch`, y su prueba lo vigila.
  "alpha_arbol_entero",       // qué tandas del Árbol completaste, y cuántas veces
  // Y LAS VICTORIAS DE CADA MINIJUEGO (22 de septiembre de 2026), con las que los mentores
  // recuperan su Artefacto.
  //
  // ÉSTA YA NO ES COMO LAS DE ARRIBA, desde el 2 de octubre de 2026, y el comentario de antes
  // —«un mapa de números sin nombre, sin fecha y sin identificador; `victorias.mjs` no tiene un
  // `fetch`»— se queda sólo con su última mitad. `victorias.mjs` sigue sin tener un `fetch`, y
  // su prueba lo sigue vigilando; lo que pasa es que ahora hay un fichero al lado que sí lo
  // tiene (`victoriasDelServidor.mjs`), porque las victorias se guardan en la cuenta.
  //
  // SIGUE SIENDO NECESARIA, Y NO POR COSTUMBRE: la escena 3D pinta dentro del cuadro y
  // `victorias.devueltos()` se consulta mientras dibuja, así que el mundo necesita la copia
  // local para saber si un mentor ya tiene su Artefacto. Sin ella no es que se pierda un
  // recuerdo: es que no se puede dibujar. Lo que sube se declara en `data/legal/privacidad.js`.
  "alpha_victorias",          // qué minijuegos has ganado, y en el Pórtico qué lecciones
  // Y LO QUE HAS RESCATADO CON MNEMO, por el mismo razonamiento: un mapa de números —lección:
  // veces—, sin nombre, sin fecha y sin identificador. Sirve para que el guardián del Olvido te
  // enseñe primero lo que no has vuelto a mirar. `rescate.mjs` no tiene un solo `fetch`.
  "alpha_mnemo_rescatadas",   // qué lecciones has rescatado con Mnemo, y cuántas veces
  // Y CUÁL DE LAS TRES NAVES ES LA TUYA (M7, 3 de octubre de 2026). Una palabra —«exploradora»,
  // «recolectora», «insignia»— y nada más: es el color del vehículo que pilotas en el
  // Recorrido. No es nota, no cuenta para la Liga y no sube al expediente de nadie. Está aquí y
  // no en el servidor porque perderla no pierde nada: vuelves a volar la Exploradora.
  "alpha_nave",               // la nave que elegiste en la cabina de la Lanzadera
  // Y QUÉ SITIOS DEL MUNDO HAS PISADO, para que el plano no los enseñe todos desde el primer
  // día. Es una lista de nombres de sitio —«explanada», «templo»—, sin nombre de nadie, sin
  // fecha y sin identificador, y nunca sale del navegador.
  "alpha_mundo_visto",        // los sitios del mundo por los que ya has pasado
  // Y QUÉ TENÍAS ABIERTO LA ÚLTIMA VEZ (`haberEstado.mjs`, 2 de octubre de 2026). Es la otra
  // mitad de la de arriba y entra por la misma razón, pero conviene decir para qué sirve,
  // porque no es obvio: **la ceremonia de abrir un sitio es «qué pasa el día que lo ganas», y
  // el servidor no contesta eso**. Contesta qué tienes abierto ahora. El día que lo ganaste es
  // la diferencia entre lo de ahora y lo de la última vez, y sin memoria no se puede calcular.
  //
  // Es una lista de nombres de sitio —«fragua», «portico»—, sin nombre de nadie, sin fecha y
  // sin identificador, y es CACHÉ y no verdad: perderla sólo repite una ceremonia o hace andar
  // una vez más. Quién tiene un sitio abierto lo decide el servidor (`GET /api/mundo/puertas`)
  // y nada de aquí.
  "alpha_mundo_abierto",      // qué sitios tenías abiertos la última vez, para saber cuál es nuevo
  // Y QUÉ PODERES TE HA ENTREGADO YA MNEMO (`poderes.mjs`, 21 de octubre de 2026, M21). Es
  // exactamente la misma clase que la de arriba, y entra por la misma razón: **el servidor
  // contesta si te lo has GANADO —quince lecciones— y no si ya viste la escena en la que te lo
  // dan**. Sin memoria, Mnemo te daría el fogonazo cada vez que subieras a verle.
  //
  // Es una lista de nombres de poder —«fogonazo»—, sin nombre de nadie, sin fecha y sin
  // identificador, y es CACHÉ y no verdad: perderla repite una ceremonia, nada más. Si alguien
  // la escribe a mano no se regala ningún poder, porque tener uno son las DOS cosas y la otra
  // la decide el servidor (`loLleva`, en `poderes.mjs`).
  "alpha_poderes_recogidos",  // qué poderes te ha dado ya Mnemo, para no repetir la entrega
  //                             (y desde J8 las cartas del combate que te dieron Ariadna y el
  //                             Astronauta: la misma lista y el mismo razonamiento)
  // Y QUÉ HAS VISTO DETRÁS DE CADA PUERTA DEL ÁGORA (`novedadesDelAgora.mjs`, 28 de octubre de
  // 2026), para que su neón pulse sólo si hay algo nuevo. Es la misma clase que la de los sitios
  // abiertos: los identificadores de las sesiones, del reto y de las victorias que ya estaban la
  // última vez que abriste cada puerta —datos públicos de la plaza, no tuyos—, sin nombre, sin
  // fecha y sin identificador del alumno. CACHÉ y no verdad: perderla sólo hace que una puerta
  // vuelva a pulsar.
  "alpha_agora_visto",        // qué había detrás de cada puerta del Ágora la última vez
  // Y EL ÓBOLO DEL CAÑÓN (`estigia.mjs`), la moneda que se recoge bajando a la grieta: un sí o
  // un no, sin nombre, sin fecha y sin identificador, del estado de un juego que el alumno ha
  // aceptado empezar. Mismo razonamiento y mismo compromiso que las de arriba.
  "alpha_obolo",              // si ya has recogido la moneda del Cañón
  // CÓMO LE FUE AL MUNDO 3D LA ÚLTIMA VEZ EN ESTE NAVEGADOR: los cuadros por segundo y si
  // hubo que aligerar. Va aquí y no en CON_PERMISO por un motivo que no es el de los juegos y
  // conviene escribirlo: **sin esto no se puede arreglar lo que va mal**. Nació el 25 de
  // septiembre de 2026 porque en el Chromebook del aula el sonido se cortaba y las
  // herramientas de desarrollo están bloqueadas por el centro; el único modo de saber qué
  // pasaba en ESA máquina era que la propia máquina lo apuntara. Son dos números, no salen
  // del navegador —`ligereza.mjs` no tiene un solo `fetch`— y describen al aparato, no a la
  // persona. Preguntarle a un menor si le dejamos recordar a cuántos cuadros por segundo le
  // fue el mundo sería una pregunta más sin ninguna ganancia de privacidad.
  "alpha_equipo",             // cómo le fue al mundo 3D aquí: para poder aligerarlo solo
  // LA MARCA DE DUEÑO (`duenoDelNavegador.mjs`). Necesaria y no con permiso porque es justo lo
  // que protege a quien entra después en un ordenador compartido: pedir permiso para no
  // enseñarle a B lo de A sería poner la protección detrás de una pregunta que se puede negar.
  // Es una huella del identificador, no el identificador, y no sale del navegador.
  "alpha_dueno",              // de qué cuenta es lo guardado, para borrarlo si entra otra
  CLAVE,                      // esta misma respuesta: sin ella no se podría respetar
];

/**
 * Lo que solo se guarda con permiso, agrupado por ASUNTO y no por clave: se pregunta una vez
 * por motivo, no una vez por fichero. Si mañana hay un segundo asunto, se añade aquí y todo
 * lo demás —la pregunta, el borrado, el portero— sigue funcionando.
 */
export const CON_PERMISO = {
  referidos: {
    titulo: "Has llegado por la invitación de alguien",
    dice: "Para que a quien te invitó se le reconozca, hay que dejar una marca en este "
      + "navegador. No lleva tu nombre ni sirve para nada más. Si dices que no, la Academia "
      + "funciona exactamente igual: lo único que pasa es que esa persona no se lleva nada.",
    si: "Dejar la marca",
    no: "No, gracias",
    claves: ["alpha_ref", "alpha_visitor", "alpha_ref_claimed"],
  },
};

export const ASUNTOS = Object.keys(CON_PERMISO);

/** Todas las claves que necesitan permiso, vengan del asunto que vengan. */
export function clavesConPermiso() {
  return ASUNTOS.flatMap((a) => CON_PERMISO[a].claves);
}

/** Limpia lo que venga: asuntos inventados, valores que no son sí ni no, y basura. */
export function saneado(guardado) {
  const fuera = {};
  if (!guardado || typeof guardado !== "object") return fuera;
  for (const a of ASUNTOS) {
    if (typeof guardado[a] === "boolean") fuera[a] = guardado[a];
  }
  return fuera;
}

export function lee(almacen) {
  try {
    return saneado(JSON.parse(almacen.getItem(CLAVE)));
  } catch {
    return {};
  }
}

/**
 * Apunta la respuesta y, si es que no, **borra lo que se hubiera guardado antes con un sí**.
 * Ese borrado es la mitad importante: sin él, cambiar de opinión no cambiaría nada.
 */
export function guarda(almacen, asunto, respuesta) {
  if (!ASUNTOS.includes(asunto)) return lee(almacen);
  const estado = { ...lee(almacen), [asunto]: respuesta === true };
  try {
    almacen.setItem(CLAVE, JSON.stringify(estado));
  } catch {
    // Sin almacenamiento -ventana privada- no se guarda nada, que es la respuesta más
    // conservadora posible: se volverá a preguntar, y mientras tanto no se guarda nada más.
  }
  if (!estado[asunto]) olvida(almacen, asunto);
  return estado;
}

/** Quita del navegador todo lo que ese asunto había guardado. */
export function olvida(almacen, asunto) {
  const asuntoBueno = CON_PERMISO[asunto];
  if (!asuntoBueno) return;
  for (const clave of asuntoBueno.claves) {
    try {
      almacen.removeItem(clave);
    } catch {
      // Si no se puede quitar, no se puede; no hay nada mejor que hacer aquí.
    }
  }
}

/** `true` SOLO si hay un sí explícito. La duda cuenta como no. */
export function puede(estado, asunto) {
  return saneado(estado)[asunto] === true;
}

/** Si todavía no ha contestado. Un `false` guardado ya es una respuesta. */
export function hayQuePreguntar(estado, asunto) {
  return ASUNTOS.includes(asunto) && !(asunto in saneado(estado));
}
